module.exports = __webpack_public_path__ + "static/media/bg.72c5c2ab.jpg";